var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const Svg8White = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "83px",
    viewBox: "0 0 78 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8,19.8 L53.4,35.4 C52.8,36 52.5,36.5 52.5,37.7 L52.5,81.3 C52.5,81.8 52.9,82.2 53.4,82.2 L70.3,82.2 C70.8,82.2 71.2,81.8 71.2,81.3 L71.2,20.2 C71.3,19.6 70.9,18.7 69.8,19.8 M22.7,40 L6.3,55.6 C5.7,56.2 5.4,56.7 5.4,57.9 L5.4,81.2 C5.4,81.7 5.8,82.1 6.3,82.1 L23.2,82.1 C23.7,82.1 24.1,81.7 24.1,81.2 L24.1,40.4 C24.2,39.9 23.8,39 22.7,40",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3,0.9 C77.3,0.8 77.3,0.6 77.2,0.5 C77.1,0.4 77,0.4 76.9,0.4 L76.7,0.4 L64.2,3.2 L64,3.2 C63.9,3.2 63.8,3.3 63.8,3.3 C63.6,3.5 63.6,3.8 63.8,4 L63.9,4.1 L66.8,7 L38.4,35.4 L25.3,22.3 C25.2,22.2 24.9,22.2 24.8,22.3 L21.2,25.9 L0.2,46.9 C0.1,47 0.1,47.3 0.2,47.4 L3.8,51 C3.9,51.1 4.2,51.1 4.3,51 L25.1,30.3 L34.6,39.8 L38.2,43.4 C38.3,43.5 38.6,43.5 38.7,43.4 L70.9,11.2 L73.9,14.2 C74.1,14.4 74.4,14.4 74.6,14.2 C74.7,14.1 74.7,14 74.7,13.9 L77.5,1.1 L77.3,0.9 L77.3,0.9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,42.8 L38.5,50.8 C38.3,50.9 38.1,50.9 38,50.8 L30.8,43.5 C29.5,42.2 29.2,43.3 29.2,43.8 L29.2,81.4 C29.2,81.9 29.6,82.3 30.1,82.3 L47,82.3 C47.5,82.3 47.9,81.9 47.9,81.4 L47.9,43.2 C47.9,42.5 47.5,41.6 46.4,42.8",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg8White);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/8_white.8e2f49cf7dc7f1fac4f7a1fe26090914.svg";